module.exports = __webpack_public_path__ + "img/imagem-detalhada-palmeiras-02.b530344c.png";